import React from 'react';

const Footer = () => {
	return (
		<footer>
			{/* GitHub and credit details are commented out */}
			{/**
			<a href="https://github.com/bchiang7/v4">
				<div>Designed &amp; Built by Brittany Chiang</div>
			</a>
			*/}
		</footer>
	);
};

export default Footer;
